import { cx } from "../../lib/cx.js";
/* empty css                */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/SummaryStat/SummaryStat.tsx
/** One figure in a SummaryStats card: a label over a large value (a `dt` and a `dd`). */
function SummaryStat({ label, value, hint, size = "md", className, ...rest }) {
	return /* @__PURE__ */ jsxs("div", {
		...rest,
		className: cx("ds-summary-stat", `ds-summary-stat--${size}`, className),
		children: [
			/* @__PURE__ */ jsx("dt", {
				className: "ds-summary-stat__label",
				children: label
			}),
			/* @__PURE__ */ jsx("dd", {
				className: "ds-summary-stat__value",
				children: value
			}),
			hint && /* @__PURE__ */ jsx("dd", {
				className: "ds-summary-stat__hint",
				children: hint
			})
		]
	});
}
/**
* The pending-pay summary: a card of figures (the pending pay date, records, total, reps
* affected), with actions and a "last updated" line at the end. With `empty`, it says
* what's missing instead.
*/
function SummaryStats({ children, actions, footer, empty, className, ...rest }) {
	if (empty) return /* @__PURE__ */ jsxs("section", {
		...rest,
		className: cx("ds-summary-stats", "ds-summary-stats--empty", className),
		children: [/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("p", {
			className: "ds-summary-stats__empty-title",
			children: empty.title
		}), empty.description && /* @__PURE__ */ jsx("p", {
			className: "ds-summary-stats__empty-description",
			children: empty.description
		})] }), actions && /* @__PURE__ */ jsx("div", {
			className: "ds-summary-stats__end",
			children: actions
		})]
	});
	return /* @__PURE__ */ jsxs("section", {
		...rest,
		className: cx("ds-summary-stats", className),
		children: [/* @__PURE__ */ jsx("dl", {
			className: "ds-summary-stats__list",
			children
		}), (actions || footer) && /* @__PURE__ */ jsxs("div", {
			className: "ds-summary-stats__end",
			children: [actions, footer && /* @__PURE__ */ jsx("p", {
				className: "ds-summary-stats__footer",
				children: footer
			})]
		})]
	});
}
//#endregion
export { SummaryStat, SummaryStats };

//# sourceMappingURL=SummaryStat.js.map